import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../../../components/global/modal/withModal';
import WarningIcon from '../../../../../../../components/icons/WarningIcon';
import Button from '../../../../../../../components/global/Button';

const propTypes = {
  onSave: PropTypes.func.isRequired,
  onLeave: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

const SaveChangesRequestConfirm = ({ onSave, onRequestClose, onLeave }) => {
  return (
    <div className="d-flex flex-column align-items-center p-2">
      <WarningIcon size="32" className="mb-1" />{' '}
      <h4 className="text-center mb-3">Leave without saving?</h4>
      <p className="text-center">Your changes will not be saved</p>
      <div className="configurator-button-group">
        <Button
          onClick={() => {
            onRequestClose();
            onLeave();
          }}
          btnStyle="danger"
          btnOutline
        >
          Leave without saving
        </Button>
        <Button
          onClick={() => {
            onSave();
            onRequestClose();
          }}
        >
          Save and leave
        </Button>
      </div>
      <Button onClick={onRequestClose} btnOutline className="w-100 mt-1">
        Continue editing
      </Button>
    </div>
  );
};

SaveChangesRequestConfirm.propTypes = propTypes;

export const MARKETING_MATERIAL_CONFIGURATOR_SAVE_CHANGES_MODAL =
  'modal/MARKETING_MATERIAL_CONFIGURATOR_SAVE_CHANGES';

export default withModal(SaveChangesRequestConfirm, {
  name: MARKETING_MATERIAL_CONFIGURATOR_SAVE_CHANGES_MODAL,
  hideHeader: true,
  size: 'sm',
});
